import React, { useState, useEffect } from 'react';
import Login from './pages/Login/Login';
// import { GlobalStyle } from './styles/GlobalThemeStyle';
import {
	GlobalStyle,
	XContainer,
	Theme,
	XLayout,
	XThemeLayout,
} from './styles/GlobalThemeStyleCQ';
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import Page404 from './pages/Page404';
import PrivateRoute from './components/PrivateRoute';
import { Layout, Spin } from 'antd';
import 'bootstrap/dist/css/bootstrap.min.css';
import Dashboard from './pages/Dashboard/Dashboard';
import ForgotEmailPassword from './pages/ForgotEmailPassword/ForgotEmailPassword';
import VerifyOtp from './pages/VerifyOtp/VerifyOtp';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import CaseForm from './pages/CaseForm/CaseForm';
import Manage from './pages/Manage/Manage';
import Profile from './pages/Profile/Profile';
import CaseClosure from './pages/CaseClosure/CaseClosure';
import CasePreparation from './pages/CasePreparation/CasePreparation';
import AnalyseCoverage from './pages/AnalyseCoverage/AnalyseCoverage';
import ChangePassword from './pages/ChangePassword/ChangePassword';
import CaseManagement from './pages/Manage/CaseManagement';
import CaseAnalysis from './pages/CaseAnalysis/CaseAnalysis';
import CaseAnalysisView from './pages/CaseAnalysis/CaseAnalysisView';
import CaseView from './pages/CaseView/CaseView';
import CaseFilings from './pages/CaseFilings/CaseFilings';
import CaseLiterature from './pages/CaseLiterature/CaseLiterature';
import FeedBackView from './pages/FeedBackAnalysis/FeedBackView';
import FeedBackList from './pages/FeedBackAnalysis/FeedBackList';
import Sidebar from './components/Sidebar/Sidebar';
import AppealLetterView from './pages/AppealLetter/AppealLetterView';
import AppealLetter from './pages/AppealLetter/AppealLetter';
import InsuranceCompanyList from './pages/InsuranceCompany/InsuranceCompanyList';
import HospitalList from './pages/Hospital/HospitalList';
import HospitalForm from './pages/Hospital/HospitalForm';
import ScrollToTop from './components/ScrollToTop';
import Regions from './pages/Regions/Regions';
import Organization from './pages/Organization/Organization';
import OrganizationForm from './pages/Organization/OrganizationForm';
import ModuleForm from './pages/ModuleForm/ModuleForm';
import AddEditUser from './pages/Manage/AddEditUser';
import CaseFilingManagement from './pages/CaseFilingManagement/CaseFilingManagement';
import ManageMAPlansAppeal from './pages/MAPlansAppealsProcessing/Manage';
import PayerConfiguration from './pages/PayerConfiguration/PayerConfiguration';
import PayerConfigurationForm from './pages/PayerConfiguration/PayerConfigurationForm';
import Reimbursements from './pages/Reimbursements/Reimbursements';
import ReimbursementsView from './pages/Reimbursements/ReimbursementsView';
import Consent from './pages/Consent/Consent';
import ManageAppealLetters from './pages/AssignAppealLetter/Manage';
import CodingTeamAssign from './pages/AssignAppealLetter/CodingTeamAssign';
import MDAdvisorAssign from './pages/AssignAppealLetter/MDAdvisorAssign';
import AppealLetterPreview from './pages/CaseFilings/AppealLetterPreview';
import WebviewTest from './pages/WebviewTest/WebviewTest';
import InsuranceCompanyForm from './pages/InsuranceCompany/InsuranceCompanyForm';
import './App.css';
import Aipa from './pages/Aipa/Aipa';
import NotificationManagement from './pages/Notification/NotificationManagement';
import NewAipa from './pages/AipaNew/NewAipa';
import ActivityLogs from './pages/ActivityLogs/ActivityLogs';
import ActivityLogDetails from './pages/ActivityLogs/ActivityLogDetails/ActivityLogDetails';
import Batches from './pages/Batches/Batches';
import CreateBatch from './pages/Batches/CreateBatch';
import BatchDetails from './pages/Batches/BatchDetails';
import AddRegion from './pages/Regions/AddRegion';
import PoliciesCodes from './components/PoliciesCodes/PoliciesCodes';
import StepCaseForm from './pages/CaseForm/StepCaseForm';
import VoiceAssistance from './pages/VoiceAssistance/VoiceAssistance';
import CaseAgent from './pages/VoiceAssistance/CaseAgent';
import ShieldMaxx from './pages/ShieldMaxx/ShieldMaxx';
import SimulateEhr from './pages/SimulateEhr/SimulateEhr';
import CreateSimulateEhr from './pages/SimulateEhr/CreateSimulateEhr';
import ReclaimDashboard from './pages/Dashboard/ReclaimDashboard';
import { checkModulePermissions } from './utils/helper';
import NanoDashboard from './pages/Dashboard/NanoDashboard';
import CallInsurance from './pages/CallInsurance/CallInsurance';

const { Header, Content, Footer } = Layout;

function App(props) {
	const [collapsed, setCollapsed] = useState(false);
	const [permissionsReady, setPermissionsReady] = useState(false);
	const [permissionsVersion, setPermissionsVersion] = useState(0);
	// Functions
	const toggle = (data) => {
		setCollapsed(data);
	};

	// Wait for permissions to be available in localStorage
	useEffect(() => {
		const checkPermissions = () => {
			const permissions = localStorage.getItem('permissions');
			if (permissions) {
				setPermissionsReady(true);
			} else {
				setTimeout(checkPermissions, 100); // Retry after 100ms
			}
		};
		checkPermissions();
	}, []);

	// Listen for changes to permissions in localStorage
	useEffect(() => {
		const handleStorageChange = (e) => {
			if (e.key === 'permissions' && e.newValue) {
				// Permissions have been updated, increment version to trigger re-render
				setPermissionsVersion(prev => prev + 1);
			}
		};

		// Listen for storage events (from other tabs/windows)
		window.addEventListener('storage', handleStorageChange);

		// Also listen for direct localStorage changes in the same tab
		const originalSetItem = localStorage.setItem;
		localStorage.setItem = function(key, value) {
			originalSetItem.apply(this, arguments);
			if (key === 'permissions' && value) {
				// Permissions have been updated, increment version to trigger re-render
				setPermissionsVersion(prev => prev + 1);
			}
		};

		return () => {
			window.removeEventListener('storage', handleStorageChange);
			localStorage.setItem = originalSetItem;
		};
	}, []);

	return (
		<ThemeProvider theme={Theme}>
			<GlobalStyle />
			<BrowserRouter>
				<ScrollToTop />
				<XThemeLayout>
					<Routes>
						<Route path="/login" element={<Login />}></Route>
						<Route
							path="/forgot-email-password"
							element={<ForgotEmailPassword />}
						></Route>
						<Route path="/consent" element={<Consent />}></Route>
						<Route
							path="/reset-password"
							element={<ResetPassword />}
						></Route>
						<Route
							path="/verify-otp"
							element={<VerifyOtp />}
						></Route>
						<Route
							path="/webview-test"
							element={<WebviewTest />}
						></Route>
						<Route
							path="/"
							element={
								<Layout>
									<Sidebar
										collapsed={collapsed}
										toggle={(data) => toggle(data)}
									/>
									<Layout>
										<Content
											className="mainContent"
											style={{
												marginLeft:
													window.innerWidth <= 991
														? 0
														: collapsed
														? 80
														: 210,
												width:
													window.innerWidth <= 991
														? '100%'
														: collapsed
														? 'calc(100% - 80px)'
														: 'calc(100% - 210px)',
												transition: 'all 0.2s ease',
											}}
										>
											<div
												style={{
													marginLeft: '0px',
													width: '100%',
												}}
											>
												<Outlet />
											</div>
										</Content>
									</Layout>
								</Layout>
							}
						>
							<Route
								exact
								path="/"
								element={
									<PrivateRoute>
										{!permissionsReady ? (
											<div
												style={{
													display: 'flex',
													justifyContent: 'center',
													alignItems: 'center',
													height: '100vh',
												}}
											>
												<Spin
													size="large"
													tip="Loading permissions..."
												/>
											</div>
										) : (
											<>
												{checkModulePermissions(
													'nano-dashboard',
												).authorized ? (
													<NanoDashboard key={permissionsVersion} />
												) : (
													<Dashboard key={permissionsVersion} />
												)}
											</>
										)}
									</PrivateRoute>
								}
							/>
							<Route
								exact
								path="/case/add"
								element={
									<PrivateRoute>
										<StepCaseForm />
										{/* <CaseForm /> */}
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/case/edit/:id"
								element={
									<PrivateRoute>
										{/* <CaseForm /> */}
										<StepCaseForm />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/case/view/:id"
								element={
									<PrivateRoute>
										<CaseView collapsed={collapsed} />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/case/filings/:id"
								element={
									<PrivateRoute>
										<CaseFilings collapsed={collapsed} />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/case/filings/preview/:id"
								element={
									<PrivateRoute>
										<AppealLetterPreview />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/case/ma/:id"
								element={
									<PrivateRoute>
										<CaseFilings collapsed={collapsed} />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/feedback"
								element={<FeedBackList />}
							></Route>
							<Route
								exact
								path="/feedback/view/:id"
								element={<FeedBackView />}
							></Route>
							<Route
								exact
								path="/case-management"
								element={
									<PrivateRoute>
										<CaseManagement collapsed={collapsed} />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/user-role-management"
								element={
									<PrivateRoute>
										<Manage />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/user-role-management/user/:id"
								element={
									<PrivateRoute>
										<AddEditUser />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/user-role-management/user"
								element={
									<PrivateRoute>
										<AddEditUser />
									</PrivateRoute>
								}
							></Route>

							<Route
								exact
								path="/case-filing-management"
								element={
									<PrivateRoute>
										<CaseFilingManagement collapsed={collapsed} />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/md-advisor"
								element={
									<PrivateRoute>
										<CaseFilingManagement collapsed={collapsed} />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/coding-team"
								element={
									<PrivateRoute>
										<CaseFilingManagement collapsed={collapsed} />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/appeal-letter-assignment"
								element={
									<PrivateRoute>
										<ManageAppealLetters collapsed={collapsed} />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/appeal-letter-assignment/assign-coding-team/:id"
								element={
									<PrivateRoute>
										<CodingTeamAssign collapsed={collapsed} />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/appeal-letter-assignment/assign-md-advisor/:id"
								element={
									<PrivateRoute>
										<MDAdvisorAssign collapsed={collapsed} />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/standard-appeal-tat"
								element={
									<PrivateRoute>
										<ManageMAPlansAppeal collapsed={collapsed} />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/case-closure"
								element={
									<PrivateRoute>
										<CaseClosure />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/case-literature"
								element={
									<PrivateRoute>
										<CaseLiterature />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/case-analysis"
								element={
									<PrivateRoute>
										<CaseAnalysis collapsed={collapsed} />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/case-analysis/:id"
								element={
									<PrivateRoute>
										<CaseAnalysisView collapsed={collapsed} />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/appeal-letter"
								element={
									<PrivateRoute>
										<AppealLetter />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/appeal-letter/:id"
								element={
									<PrivateRoute>
										<AppealLetterView />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/insurance-company"
								element={
									<PrivateRoute>
										<InsuranceCompanyList />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/insurance-company/add"
								element={
									<PrivateRoute>
										<InsuranceCompanyForm />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/insurance-company/edit/:id"
								element={
									<PrivateRoute>
										<InsuranceCompanyForm />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/hospital"
								element={
									<PrivateRoute>
										<HospitalList />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/hospital/add"
								element={
									<PrivateRoute>
										<HospitalForm />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/hospital/edit/:id"
								element={
									<PrivateRoute>
										<HospitalForm />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/module/add"
								element={
									<PrivateRoute>
										<ModuleForm />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/module/edit/:id"
								element={
									<PrivateRoute>
										<ModuleForm />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/open-analysis"
								element={
									<PrivateRoute>
										<AnalyseCoverage collapsed={collapsed} />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/aipa"
								element={
									<PrivateRoute>
										<NewAipa collapsed={collapsed} />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/shield-maxx"
								element={
									<PrivateRoute>
										<ShieldMaxx collapsed={collapsed} />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/call-insurance"
								element={<CallInsurance />}
							></Route>
							{/* <Route
								exact
								path="/new-aipa"
								element={
									<PrivateRoute>
										<NewAipa />
									</PrivateRoute>
								}
							></Route> */}
							<Route
								exact
								path="/case-preparation"
								element={<CasePreparation />}
							></Route>
							<Route
								exact
								path="/profile"
								element={
									<PrivateRoute>
										<Profile />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/change-password"
								element={
									<PrivateRoute>
										<ChangePassword />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/regions"
								element={
									<PrivateRoute>
										<Regions />
									</PrivateRoute>
								}
							></Route>

							<Route
								exact
								path="/regions/add"
								element={
									<PrivateRoute>
										<AddRegion />
									</PrivateRoute>
								}
							></Route>

							<Route
								exact
								path="/regions/edit/:id"
								element={
									<PrivateRoute>
										<AddRegion />
									</PrivateRoute>
								}
							></Route>

							<Route
								exact
								path="/organization"
								element={
									<PrivateRoute>
										<Organization />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/organization/add"
								element={
									<PrivateRoute>
										<OrganizationForm />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/organization/edit/:id"
								element={
									<PrivateRoute>
										<OrganizationForm />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/payer-configuration"
								element={
									<PrivateRoute>
										<PayerConfiguration />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/payer-configuration/add"
								element={
									<PrivateRoute>
										<PayerConfigurationForm />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/payer-configuration/edit/:id"
								element={
									<PrivateRoute>
										<PayerConfigurationForm />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/reimbursements"
								element={
									<PrivateRoute>
										<Reimbursements />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/reimbursements/:id"
								element={
									<PrivateRoute>
										<ReimbursementsView />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/notification-management"
								element={
									<PrivateRoute>
										<NotificationManagement />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/logs"
								element={
									<PrivateRoute>
										<ActivityLogs />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/logs/:id"
								element={
									<PrivateRoute>
										<ActivityLogDetails />
									</PrivateRoute>
								}
							></Route>

							<Route
								exact
								path="/maxx-v1"
								element={
									<PrivateRoute>
										<Batches />
									</PrivateRoute>
								}
							/>
							<Route
								exact
								path="/create-workload"
								element={
									<PrivateRoute>
										<CreateBatch />
									</PrivateRoute>
								}
							/>
							<Route
								exact
								path="/batch-details/:id"
								element={
									<PrivateRoute>
										<BatchDetails />
									</PrivateRoute>
								}
							/>
							<Route
								exact
								path="/policies-codes"
								element={
									<PrivateRoute>
										<PoliciesCodes />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/agent-maxx"
								element={<VoiceAssistance collapsed={collapsed} />}
							/>
							<Route
								exact
								path="/agent-maxx/:conversationId"
								element={<VoiceAssistance collapsed={collapsed} />}
							/>
							<Route
								exact
								path="/case-agent"
								element={<CaseAgent />}
							/>
							<Route
								exact
								path="/case-agent/:conversationId"
								element={<CaseAgent />}
							/>
							<Route
								exact
								path="/simulate-ehr"
								element={
									<PrivateRoute>
										<SimulateEhr />
									</PrivateRoute>
								}
							></Route>
							<Route
								exact
								path="/create-simulation"
								element={
									<PrivateRoute>
										<CreateSimulateEhr />
									</PrivateRoute>
								}
							></Route>
						</Route>
						<Route path="/*" element={<Page404 />} />
					</Routes>
				</XThemeLayout>
			</BrowserRouter>
		</ThemeProvider>
	);
}

export default App;
